const div = document.getElementById("rotationBanner");
if (!div) return;
let visible = false;

//TRIGGER ELEMENT
const sentinel = document.createElement("div");
sentinel.style.position = "absolute";
sentinel.style.top = "400px";
sentinel.style.height = "1px";
sentinel.style.width = "1px";
sentinel.style.pointerEvents = "none";
sentinel.style.visibility = "hidden";
document.body.appendChild(sentinel);

//INTERSECTION OBSERVER
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop >= 400 && !visible) {
        div.style.display = "flex";
        setTimeout(() => {
          div.style.transform = "translate(-50%, 0)";
        }, 50);
        visible = true;
      }
      else if (scrollTop < 400 && visible) {
        div.style.transform = "translate(-50%, 100%)";
        div.addEventListener(
          "transitionend",
          () => {
            if (!visible) {
              div.style.display = "none";
            }
          },
          { once: true },
        );
        visible = false;
      }
    })
  },
  {
    threshold: 0,
    rootMargin: "0px",
  },
)
observer.observe(sentinel);

//TEXT ROTATION
const items = document.querySelectorAll(".rotating-slider li");
let index = 0;
function showNext() {
  items.forEach((el) => el.classList.remove("active"));
  items[index].classList.add("active");
  index = (index + 1) % items.length;
}
showNext();
const rotationInterval = setInterval(showNext, 2000);

// CLEANUP FUNCTION
function cleanup() {
  observer.disconnect();
  bannerObserver.disconnect();
  clearInterval(rotationInterval);
}

window.cleanupScrollBanner = cleanup;